import React from 'react';
import newBadgeImg from '../assets/icons/label-new-flash.svg';
import './../css/overview.scss';

const CarouselCard = ({ newBadge, title, description, imageUrl, urlLink }) => {
  return (
    <div className="col-lg-4 col-md-4 col-sm-4 px-1 overview-lelang-card-carousel">
      {newBadge && (
        <div className="new-badge">
          <img src={newBadgeImg} alt="carousel" />
        </div>
      )}
      <div className="overview-auction-card">
        <div className="p-3">
          <img className="card-img-top" alt="on-site-auction" src={imageUrl} />
        </div>
        <div className="card-body">
          <h5 className="card-title-overview-subtitle">{title}</h5>
          <p className="card-text overview-paragraph">{description}</p>
          <a href={urlLink} target="_blank" rel="noreferrer">
            Lihat Selengkapnya &#8594;
          </a>
        </div>
      </div>
    </div>
  );
};

export default CarouselCard;
